<template>
    <v-container>
        <v-row no-gutters>
            <v-col
                cols="12"
                md="4"
                sm="4"
            >
                <h1>Stock {{ company }}</h1>
            </v-col>
            <v-col
                cols="12"
                md="4"
                sm="4"
            >
                <v-switch
                v-model="gmwswitch"
                color="red"
                label="GMW"
                hide-details
                ></v-switch>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="filteredStocks"
            items-per-page="-1"
        >
            <template v-slot:thead>
                <tr>
                    <td>
                        <v-text-field v-model="companysearch" class="ma-2" density="compact" placeholder="Company" hide-details></v-text-field>
                    </td>
                    <td>
                        <v-text-field v-model="typesearch" class="ma-2" density="compact" placeholder="type" hide-details></v-text-field>
                    </td>
                    <td>
                        <v-text-field v-model="productsearch" class="ma-2" density="compact" placeholder="product" hide-details></v-text-field>
                    </td>
                    <td>
                        <v-text-field v-model="stocksearch" class="ma-2" density="compact" placeholder="Stock" hide-details></v-text-field>
                    </td>
                </tr>
            </template>  
            
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon
                    class="me-2"
                    @click="showcurrentyear(item)"
                >
                    mdi-book-open-page-variant
                </v-icon>
            </template>
        </v-data-table>
        <div v-if="showStockBook">
            <StockBook :showStockBook="showStockBook" :selectedProduct="selectedProduct" :startDate="startDate" :endDate="endDate" :company="company" @closedialog="closedialog"/>
        </div>
        <div v-if="showMessage">
            <ShowError @closesnackbar="closesnackbar"/>
        </div>
    </v-container>
</template>
<script setup>
    import { ref, provide, computed, onMounted,onBeforeMount, watch } from 'vue'
    import { useAuthStore } from '@/stores/AuthStore'
    import ProductService from '@/services/ProductService'
    import YearService from '@/services/YearService'
    import ShowError from '@/components/Showerror'
    import StockBook from '@/views/stock/stockbook'
    import router from '@/router'

    const authStore = useAuthStore()
    var gmwswitch = ref(authStore.gmswitch)
    //var gmwswitch = ref(true)
    var smswitch = ref(false)
    var disabledSMSwitch = ref(false)

    var stocks = ref([])
    var gmstocks = ref([])
    var gmwstocks = ref([])
    var smstocks = ref([])
    var years = ref([])
    var currentyear = ref({})

    var showMessage = ref(false)
    var msgStatus = ref('primary')
    var msg = ref('This is msg')

    //searchs
    var companysearch = ref('')
    var typesearch = ref('')
    var productsearch = ref('')
    var stocksearch = ref('')

    var headers = ref([
        {
          title: 'Company',
          align: 'start',
          sortable: true,
          key: 'company',
        },
        { title: 'Type', key: 'type' },
        { title: 'Product', key: 'productnames_productname' },
        { title: 'Stock', key: 'stock' },
        { title: 'Actions', key: 'actions', sortable: false },
    ])

    var showStockBook=ref(false)

    var selectedProduct = ref('')
    var startDate = ref('')
    var endDate = ref('')

    var company = ref('')

    provide('msgStatus', msgStatus)
    provide('msg', msg)
    provide('showMessage', showMessage)

    onBeforeMount(async () => {
        //var gmbills = await getpurchasesfromgm()
        await getstocksfromgmw()
        await getstocksfromsm()
        //purchases.value = gmwswitch.value ? gmwbills : gmbills
        //stocks.value = gmwstocksfromserver
        //purchases.value = (gmwswitch.value) ? gmwpurchases.value : ((smswitch.value)? smpurchases.value : gmpurchases.value)
        //disabledSMSwitch.value = (gmwswitch.value) ? true : false
        if(gmwswitch.value){
            company.value = 'GMW'
            stocks.value = gmwstocks.value
        }else{
            company.value = 'SM'
            stocks.value = smstocks.value
        }
        await getyear()
    })

    async function showcurrentyear(item){
        //console.log(item)
        await showstockbook(item.productnames_productname,currentyear.value.year_start,currentyear.value.year_end)
    }

    async function showall(item){
        await showstockbook(item.productnames_productname,'2000-01-01','9999-12-31')
    }

    async function showstockbook(product,startdate,enddate){
        selectedProduct.value = product
        startDate.value = startdate
        endDate.value = enddate
        showStockBook.value = true
    }

    async function getstocksfromgmw(){
        try{
            var bills = (await ProductService.getallstockgmw()).data
            gmwstocks.value = bills
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        
        return bills
    }

    async function getstocksfromsm(){
        try{
            var bills = (await ProductService.getallstocksm()).data
            smstocks.value = bills
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        
        return bills
    }

    function closesnackbar (){
        showMessage.value = false
    }

    // function closedialog (){
    //     console.log('Close dialog is called')
    //     showForm.value = false
    //     //router.go(0)
    // }

    function closedialog (){
        console.log('Close gmgw dialog is called')
        showStockBook.value = false
        //router.go(0)
    }


    function gmgmwform(){
        showStockBook.value = true
    }

    async function getyear(){
        try{
            var year = (await YearService.getall()).data
        }catch(err){
            showMessage.value = true
            msgStatus.value = 'error'
            msg.value = err.response.data.error
        }
        years.value = year
        currentyear.value = year[0]
        return year
    }

    watch(gmwswitch, async(val)=>{
        authStore.setGmswitch()
        if(gmwswitch.value){
            company.value = 'GMW'
            stocks.value = gmwstocks.value
        }else{
            company.value = 'SM'
            stocks.value = smstocks.value
        }
    })

    function filterCompany(item){
        return item.company.toLowerCase().includes(companysearch.value.toLowerCase())
    }

    function filterType(item){
        return item.type.toLowerCase().includes(typesearch.value.toLowerCase())
    }
    function filterProduct(item){
        return item.productnames_productname.toLowerCase().includes(productsearch.value.toLowerCase())
    }
    function filterStock(item){
        return item.stock >= stocksearch.value
    }

    const filteredStocks = computed(() => {
        var conditions = []

        if(companysearch.value){
            conditions.push(filterCompany)
        }

        if(typesearch.value){
            conditions.push(filterType)
        }

        if(productsearch.value){
            conditions.push(filterProduct)
        }

        if(stocksearch.value){
            conditions.push(filterStock)
        }

        if(conditions.length > 0){
            return stocks.value.filter((stock) => {
                return conditions.every((condition) => {
                    return condition(stock)
                })
            })
        }

        return stocks.value
    })
</script>